import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(22.000000, 35.000000)">
        <path
         d="M0.275568 0.818181H7.10227L14.3125 18.4091H14.6193L21.8295 0.818181H28.6562V27H23.2869V9.95881H23.0696L16.294 26.8722H12.6378L5.86222 9.89489H5.64489V27H0.275568V0.818181ZM33.217 27V0.818181H38.7525V11.6207H49.9897V0.818181H55.5124V27H49.9897V16.1847H38.7525V27H33.217Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
